import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';

const PercentageCellRenderer: React.FC<ICellRendererParams> = (props) => {
  return <>{typeof props.value === 'number' && props.value.toFixed(2)}</>;
};

export default PercentageCellRenderer;
